import styled from 'styled-components/macro';
import {spacing} from '@mui/system';

import {
  Typography as MuiTypography,
  Divider as MuiDivider,
  Stack,
  TableRow,
} from '@mui/material';

const Typography = styled(MuiTypography)(spacing);
const Divider = styled(MuiDivider)(spacing);
const StyledStack = styled(Stack)`
  margin-right: 10px;

  & > :not(style) + :not(style) {
    margin-left: 0;
  }
`;
const StyledTableRow = styled(TableRow)``;

const StyledAction = styled.div`
  cursor: pointer;
  & img {
    margin-right: 6px;
    vertical-align: text-top;
    height: 15px;
    width: 20px;
  }
`;

const StyledIcon = {
  width: '18px',
  height: '18px',
};

export {
  Typography,
  Divider,
  StyledStack,
  StyledTableRow,
  StyledAction,
  StyledIcon,
};
